import React from 'react';

import Skeleton from '@mui/material/Skeleton';
import { IconButton } from '@mui/material';

import copyIcon from '../../img/copy-icon.svg';
import openIcon from '../../img/open-in-icon.svg'
import { Button } from '@mui/material';
import { CheckBox } from '@material-ui/icons';

export default function JobDetailsSkeleton() {

  return (

    <div>
      {/* <div className='row-modal' style={{ justifyContent:'flex-end' }} >
        
        
          <div className="input-column" style={{ color: "var(--orange)" }} >
            <label>Status</label>
            <Skeleton variant="rectangular" width={200} height={36} />
          </div>
          <div className="input-column" style={{ color: "var(--orange)", marginLeft: "2em" }} >
            <label>Priority</label>
            <Skeleton variant="rectangular" width={200} height={36} />
          </div>
        
      </div>       */}

      {/* ----------------------------------------- */}

      <div className='row-modal' style={{ justifyContent: "space-between", alignItems: 'center', width: '100%', flexWrap: 'nowrap' }}>
        <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em", width: '90%' }} >
          <label>Event URL</label>
          <Skeleton variant="rectangular" width={'100%'} height={32} />
        </div>
        <div className='row-modal' style={{ width: 'fit-content', justifyContent: "flex-end", flexWrap: 'nowrap' }}>
          <IconButton variant="text"> <img src={openIcon} alt='copy icon' height='24px' /> </IconButton>
          <IconButton variant="text"> <img src={copyIcon} alt='copy icon' height='24px' /> </IconButton>
        </div>
      </div>

      {/* ----------------------------------------- */}

      <div className='row-modal' style={{ justifyContent: "flex-start", maxWidth: "750px" }}>

        <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em" }} >
          <label>QUANTITY:</label>
          <Skeleton variant="rectangular" width={200} height={32} />        </div>

        <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em" }} >
          <label>Section:</label>
          <Skeleton variant="rectangular" width={200} height={32} />        </div>

        <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em" }} >
          <label>Row:</label>
          <Skeleton variant="rectangular" width={200} height={32} />        </div>

        <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em" }} >
          <label>Cost Per Ticket:</label>
          <Skeleton variant="rectangular" width={200} height={32} />
          <div className='row-modal' style={{ marginTop: "1em", justifyContent: 'flex-start' }}>
            <CheckBox id="total" name="reward_type" value="true" style={{ margin: "0 0.5em 0 0" }} />
            <label htmlFor="total">Cost Includes Fees</label>
          </div>
        </div>

        <div className="input-column" style={{ color: "var(--orange)", marginRight: "1em" }} >
          <label>Code to Use:</label>
          <Skeleton variant="rectangular" width={200} height={32} />
        </div>

        <div style={{ color: "var(--orange)", marginRight: "1em" }} >
          <label>REWARD:</label>
          <div className="input-column" style={{ margin: '0' }}>
            <Skeleton variant="rectangular" width={200} height={32} />
          </div>

          <div className='row-modal' style={{ justifyContent: 'flex-start' }}>
            <div style={{ margin: '0 1em 0 0', display: 'flex', alignItems: 'center' }}>
              <CheckBox id="perTicket" name="reward_type" value="true" style={{ margin: '0 0.5em 0 0' }} />
              <label htmlFor="perTicket">Per Ticket</label>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }} >
              <CheckBox id="total" name="reward_type" value="true" style={{ margin: '0 0.5em 0 0' }} />
              <label htmlFor="total">Total</label>
            </div>
          </div>
        </div>

      </div>

      {/* ----------------------------------------- */}

      <div className='escalation-text'>
        <p style={{ color: "var(--orange)", margin: '0 0 0.5em 0' }} >Job Specials Instructions (user-visible)</p>
        <Skeleton variant="rectangular" width={'100%'} height={160} />
      </div>

      <div className="modal-buttons-withDelete" style={{ marginTop: "2em" }}>
        <Button variant='outlined' style={{ whiteSpace: "nowrap", backgroundColor: "white", color: "var(--red)", border: " 1px solid  var(--red)" }} >Cancel Job</Button>
        <div className="modal-buttons">
          <Button variant='contained' color='secondary' >Cancel Changes</Button>
          <Button variant='contained' sx={{ margin: '0 0 0 1em' }}>Save Changes</Button>
          <Button variant='contained' color='primary' style={{ margin: '0 0 0 1em' }}>Save And Set As Active</Button>
        </div>
      </div>

    </div>
  )
}